import clientOrders from './clientOrders';
import clients from './clients';

export default { clientOrders, clients };
